import { CardWrapper } from 'components'
import React from 'react'
import styled from 'styled-components'
import Image from 'assets/inactive-event.png'
import { colors, withCapture, _ } from 'utils'
import Button from 'components/Button'
import { useEventSlug } from 'hooks'
import { useDispatch } from 'react-redux'
import { showErrorNotification, showNotification } from 'features/notifications/notificationsSlice'
import { activeEvent } from './graphql/mutation'

const S = {
    ImageWrapper: styled.div`
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 10px;
        background: ${colors.darkOpacity(0.02)};
        border: 1px solid ${colors.statusBorder};
        border-radius: 4px;
    `,
    Image: styled.div<{ image: string }>`
        width: 450px;
        height: 180px;
        background: url(${({ image }) => image});
        background-size: cover;
        filter: drop-shadow(0px 1px 15px rgba(0, 0, 0, 0.05));
    `,
    Title: styled.p`
        margin-top: 24px;
        margin-bottom: 10px;
        font-size: 24px;
        font-weight: 500;
        text-align: center;
        color: ${colors.dark};
        opacity: 0.75;
    `,
    Description: styled.p`
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 300;
        text-align: center;
        color: ${colors.darkOpacity(0.9)};
    `,
    ActiveButton: styled(Button)`
        display: block;
        margin: auto;
    `
}

const SplashPage = ({ isRequested, fetchData }: { isRequested: boolean, fetchData: () => void }) => {
    const dispatch = useDispatch()
    const eventSlug = useEventSlug()
    const handleActiveEvent = withCapture(async () => {
        const response = await activeEvent(eventSlug)
        if (!response.data || response.errors.length) {
            dispatch(showErrorNotification(response.errors))
            return
        }
        dispatch(showNotification({
            type: 'success',
            body: _('request_active_event.success')
        }))
        fetchData()
    })

    return (
        <CardWrapper>
            <S.ImageWrapper>
                <S.Image image={Image} />
            </S.ImageWrapper>
            <S.Title>
                {_('attendee.event_not_activated_title')}
            </S.Title>
            <S.Description>
                {_('attendee.event_not_activated_description')}
            </S.Description>
            <S.ActiveButton onClick={handleActiveEvent} disabled={isRequested}>
                {_('attendee.active_event_button')}
            </S.ActiveButton>
            {isRequested && (
                <S.Description className="text-info">
                    {_('attendee.already_requested')}
                </S.Description>
            )}
        </CardWrapper>
    )
}

export default SplashPage
